export default {
    // UI
    home_search_for_product: "Termékkereső",
    conventional_alternative: "Hagyományos alterntíva",
    led_alternative: "LED alternatíva",
    search_filters_filter: "Szűrő",
    alt_filters_filter: "LED kiváltó szűrő",
    search_submit: "Termék keresése",
    results: "Eredmények",
    selected_product: "Kiválasztott termékek",
    search_input: "Írja be a termék kód, vagy leírás részét vagy egészét",
    what_type_are_you_looking_for: "Milyen típusú termék alternatívát keres?",
    recommendations_singular: "Javaslatok",
    recommendations_plural: "Javaslatok",
    your_product: "Az Ön terméke",
    search_filters_reset: "Szűrők törlése",
    results_specify: "Több, mint 10 találat van, kérjük szűkítse a keresést",
    energy_efficient: "Energiahatékony",
    active_filters: "Aktív szűrők",
    card_action: "Katalógus",
    card_show_more: "Tovább",
    card_show_less: "Kevesebb",
    card_alternative_fit: "Legjobb Philips alternatíva",
    card_perfect_fit: "Legmegfelelőbb Philips termék",
    no_results_found: "Nincs találat. Próbáljon másik keresést indítani",
    results_no_recommendations: "Elakadt? Kérjük vegye fel a kapcsolatot a helyi kapcsolattartójával a megoldás érdekében",
    led_no_recommendations: "Nincs LED kiváltó erre a termékre",
    
    
    
    
    // LED facets
    search_filter_product_type: "Termék típusa",
    lighting_type: "Lámpa típusa",
    ean: "EAN",
    product_code: "Termékkód",
    eoc: "EOC",
    family: "Család",
    discrete_wattage: "Teljesítmény",
    wattage: "Teljesítmény",
    brand: "Márka",
    driver_type: "Driver típusa",
    number_of_lamps: "Lámpák száma",
    length: "Hosszúság",
    color: "Színhőmérséklet",
    base: "Foglalat",
    local_eoc: "Helyi kód",
    lumen: "Fényáram",
    energy_saving: "Energiatakarékos",
    tiering: "Termék kategória",
    ballast_compatibility: "Előtét kompatibilitás",
    lifetime: "Élettartam",

    // Conventional facets
    ignitor: "Gyújtó",
    height: "Magasság",
    width: "Szélesség",
    mounting_hole: "Szerelési furat",
    mains_voltage: "Hálózati feszültség",
    thermal_protection: "Hővédelem",
    delta_temperature: "Hőmérséklet változás",
    energy_efficiency: "Energiahatékonyság",
    losses: "Veszteség",
    lamp_current: "Lámpa áram",
    pf_cap: "PF Cap",
};